import myaxios from "../../components/Axios";

export const getDocumentPrepareService = () => myaxios.get(`/ajax/document/prepare`)
export const getSingleDocumentService = ({ id, expand = '' }: { id: number, expand: string }) => myaxios.get(`/ajax/document/${id}?expand=${expand}`)
export const getDocumentListService = ({ link = "" }) => myaxios.get(`/ajax/document${link}`)
export const createDocumentService = ({ data }: { data: any }) => myaxios.post(`/ajax/document`, data)
export const updateDocumentService = ({ id, data }: { id: number, data: any }) => myaxios.put(`/ajax/document/${id}`, data)
export const deleteDocumentService = ({ id }: { id: number }) => myaxios.delete(`/ajax/document/${id}`)